import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context/BreadcrumbsContext';
import { Error404 } from '../ErrorPages';
import { AiUsageView } from './pages';

export const AiUsageEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Użycie AI',
      element: <AiUsageView />,
      path: '/',
      index: true,
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return <Fragment key="routes">{routes}</Fragment>;
};
